export default __webpack_public_path__ + "img/arrow-up.7a4773c2.svg";